<mat-slide-toggle [checked]="isChecked" labelPosition="before" (change)="onChanged($event)">
  <span class="switcher-label">{{ props.label | translate }}</span>
</mat-slide-toggle>
